/* ZED cart add-ons (snippets/zed-cart-addons.liquid), 2 Nov 2026.
   Add button: adds the part with _lb-product = the kit's Selleasy cart offer key, puts that offer's code
   (CART8MM / CART8BS / CART8PP) on the cart next to any codes already there, then refreshes the drawer and,
   on the cart page, the cart sections and these rows. */
(function () {
  "use strict";
  if (window.__zedCartAddons) return;
  window.__zedCartAddons = 1;

  var LB = "_lb-product";
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  // Reads the reply as text first: on iPhone a reply that wasn't JSON threw Safari's
  // "The string did not match the expected pattern." and the code step was skipped (sim tests 2 Nov).
  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.text().then(function (t) {
        var d = null;
        try { d = t ? JSON.parse(t) : {}; } catch (e) { throw { badReply: true, status: r.status }; }
        if (!r.ok || (d && d.status && d.status >= 400)) throw d;
        return d;
      });
    });
  }
  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function retryOnce(fn) {
    return fn().catch(function () { return wait(400).then(fn); });
  }
  function postJSON(url, body) {
    return getJSON(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    });
  }

  function ensureCode(code) {
    if (!code) return Promise.resolve();
    return getJSON(root + "cart.js").then(function (cart) {
      var codes = (cart.discount_codes || []).map(function (c) { return c && c.code; }).filter(Boolean);
      var has = codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
      if (has) return;
      codes.push(code);
      return postJSON(root + "cart/update.js", { discount: codes.join(",") });
    });
  }

  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    return doc.querySelector(selector);
  }

  function pageRowsSection() {
    var el = document.querySelector('[data-zca-context="page"]');
    return el && el.getAttribute("data-zca-section");
  }
  function swapPageRows(data, sid) {
    if (!sid || !data[sid]) return;
    var fresh = sectionHTML(data[sid], '[data-zca-context="page"]');
    var now = document.querySelector('[data-zca-context="page"]');
    if (!now) return;
    if (fresh) now.replaceWith(fresh);
    else now.innerHTML = "";
  }

  // Cart page: the theme's own section list (header count, items, footer) plus our rows section.
  function refreshCartPage() {
    var items = document.querySelector("cart-items");
    var sid = pageRowsSection();
    if (!items && !sid) return Promise.resolve();
    var targets = items && typeof items.getSectionsToRender === "function" ? items.getSectionsToRender() : [];
    var ids = targets.map(function (s) { return s.section; });
    if (sid) ids.push(sid);
    ids = ids.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    if (!ids.length) return Promise.resolve();
    return getJSON(window.location.pathname + "?sections=" + ids.join(",")).then(function (data) {
      targets.forEach(function (s) {
        if (!data[s.section]) return;
        var host = document.getElementById(s.id);
        if (!host) return;
        var dst = host.querySelector(s.selector) || host;
        var src = sectionHTML(data[s.section], s.selector);
        if (src) dst.innerHTML = src.innerHTML;
      });
      swapPageRows(data, sid);
    });
  }

  function refreshDrawer() {
    var mc = document.querySelector("mini-cart");
    if (mc && typeof mc.updateSectionContents === "function") {
      try { return Promise.resolve(mc.updateSectionContents()); } catch (e) { /* fall through */ }
    }
    return Promise.resolve();
  }

  function refreshAll() {
    return Promise.all([refreshDrawer(), refreshCartPage()]);
  }

  function showError(btn, msg) {
    var block = btn.closest(".zca-block");
    var el = block && block.querySelector("[data-zca-error]");
    if (el) el.textContent = msg || "Couldn't add that. Please try again.";
  }

  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest && ev.target.closest("[data-zca-add]");
    if (!btn) return;
    ev.preventDefault();
    if (btn.getAttribute("aria-busy") === "true") return;
    var id = parseInt(btn.dataset.variant, 10);
    if (!id) return;
    var props = {};
    if (btn.dataset.key) props[LB] = btn.dataset.key;
    btn.setAttribute("aria-busy", "true");
    var block = btn.closest(".zca-block");
    var errEl = block && block.querySelector("[data-zca-error]");
    if (errEl) errEl.textContent = "";

    postJSON(root + "cart/add.js", { items: [{ id: id, quantity: 1, properties: props }] })
      .catch(function (err) {
        // The add may have gone through even if its reply was unreadable: check the cart before giving up.
        if (!err || !err.badReply) throw err;
        return getJSON(root + "cart.js").then(function (cart) {
          var line = (cart.items || []).filter(function (it) {
            return it.variant_id === id && it.properties && it.properties[LB] === props[LB];
          })[0];
          if (!line) throw err;
          return { items: [line] };
        });
      })
      .then(function (res) {
        return retryOnce(function () { return ensureCode(btn.dataset.code); })
          .catch(function () { /* item is in; healCodes() puts the code on at the next page load */ })
          .then(function () { return res; });
      })
      .then(function (res) {
        btn.removeAttribute("aria-busy");
        btn.classList.add("is-added");
        var label = btn.querySelector(".zca-add-label");
        if (label) label.textContent = "Added";
        document.dispatchEvent(new CustomEvent("cart:item-add", { detail: { items: res.items || [res] } }));
        return refreshAll();
      })
      .catch(function (err) {
        btn.removeAttribute("aria-busy");
        showError(btn, err && (err.description || err.message));
      });
  });

  // Quantity changes and removes on the cart page: redraw our page rows so a removed part comes back.
  function onTheme() {
    if (typeof window.subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.source === "zed-cart-addons") return;
      var sid = pageRowsSection();
      if (!sid) return;
      getJSON(window.location.pathname + "?sections=" + sid).then(function (data) {
        swapPageRows(data, sid);
      }).catch(function () {});
    });
  }
  // Self-heal: a part added with a cart offer key but whose code didn't land gets its code on the next page load.
  var OFFER_CODES = {
    "8039986200650#offer#af654471": "CART8MM",
    "8039986626634#offer#23698e20": "CART8BS",
    "8039986233418#offer#ddad723f": "CART8PP"
  };
  function healCodes() {
    getJSON(root + "cart.js").then(function (cart) {
      var have = (cart.discount_codes || []).map(function (c) { return (c && c.code || "").toLowerCase(); });
      var need = [];
      (cart.items || []).forEach(function (it) {
        var code = it.properties && OFFER_CODES[it.properties[LB]];
        if (code && have.indexOf(code.toLowerCase()) < 0 && need.indexOf(code) < 0) need.push(code);
      });
      if (!need.length) return;
      var codes = (cart.discount_codes || []).map(function (c) { return c && c.code; }).filter(Boolean).concat(need);
      return postJSON(root + "cart/update.js", { discount: codes.join(",") }).then(refreshAll);
    }).catch(function () {});
  }

  function init() { onTheme(); healCodes(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
